import { Slot } from '@radix-ui/react-slot';
import type { ButtonHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';
type Size = 'sm' | 'md';

const VARIANTS: Record<Variant, string> = {
  primary: 'bg-primary text-foreground hover:bg-primary-hover',
  secondary: 'bg-raised text-foreground border border-border hover:border-border-strong',
  ghost: 'bg-transparent text-muted hover:text-foreground hover:bg-raised',
  danger: 'bg-transparent text-danger hover:bg-raised'
};

const SIZES: Record<Size, string> = {
  sm: 'h-8 px-3 text-[13px]',
  md: 'h-10 px-4 text-sm'
};

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  /** Render as the child element (a Link, say) while keeping button styling. */
  asChild?: boolean;
}

export function Button({ variant = 'primary', size = 'md', asChild, className, ...props }: ButtonProps) {
  const Comp = asChild ? Slot : 'button';
  return (
    <Comp
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded font-medium whitespace-nowrap',
        'transition-colors cursor-pointer',
        'disabled:cursor-not-allowed disabled:opacity-45',
        VARIANTS[variant],
        SIZES[size],
        className
      )}
      {...props}
    />
  );
}
